import { useNavigate } from "@/lib/router-compat";
import { agendar } from "./rubro";
import { Reveal } from "./Reveal";

// ---------------------------------------------------------------------------
// PRICE — "Un solo plan. Todo incluido." Single plan card + 30-day guarantee.
// ---------------------------------------------------------------------------

const included = [
  "Sitio web hecho a medida",
  "Ficha de Google optimizada",
  "Inbox unificado de WhatsApp, Instagram y Facebook",
  "Agente IA entrenado con tu tono",
  "Seguimiento automático de presupuestos",
  "Sistema de reseñas después de cada trabajo",
  "Reactivación de clientes anteriores",
  "Reporte semanal por WhatsApp y mail",
  "Soporte por WhatsApp con gente real",
];

export function HomePrice() {
  const navigate = useNavigate();

  return (
    <section
      data-screen-label="Precio"
      className="mx-auto px-6"
      style={{
        maxWidth: 1240,
        paddingTop: 24,
        paddingBottom: "clamp(80px,10vw,128px)",
      }}
    >
      <Reveal>
        <div
          className="grid overflow-hidden rounded-[20px]"
          style={{
            gridTemplateColumns: "repeat(auto-fit,minmax(min(100%,380px),1fr))",
            border: "1px solid #4C3A7A",
            background: "#120F1C",
          }}
        >
          {/* Left */}
          <div
            className="p-8 lg:p-14"
            style={{ borderRight: "1px solid #2A2340" }}
          >
            <div
              className="font-mono text-[13px] text-[#A78BFA]"
              style={{ letterSpacing: "0.08em" }}
            >
              11 — PRECIO
            </div>
            <h2
              className="font-medium text-[#EEEDF2] mt-[18px]"
              style={{
                fontSize: "clamp(34px,3.8vw,52px)",
                lineHeight: 1.05,
                letterSpacing: "-0.02em",
              }}
            >
              Un solo plan. Todo incluido.
            </h2>
            <div className="flex items-baseline gap-2.5 flex-wrap mt-8">
              <span
                className="font-semibold text-[#EEEDF2]"
                style={{
                  fontSize: "clamp(44px,5vw,64px)",
                  letterSpacing: "-0.035em",
                }}
              >
                $390.000
              </span>
              <span className="text-[#9C98A6]">ARS/mes</span>
            </div>
            <div className="flex gap-3 flex-wrap mt-7">
              <button
                onClick={() => agendar("Precio - Agendar llamada")}
                className="bg-[#7C3AED] hover:bg-[#8B5CF6] text-white font-semibold rounded-[10px] transition-colors"
                style={{ padding: "14px 22px" }}
              >
                Agendar llamada
              </button>
              <button
                onClick={() => navigate("/precios")}
                className="font-medium text-[#EEEDF2] rounded-[10px] transition-colors hover:bg-[#1A1530]"
                style={{ border: "1px solid #4C3A7A", padding: "14px 22px" }}
              >
                Ver condiciones
              </button>
            </div>
            <div
              className="grid items-center rounded-[12px] mt-8"
              style={{
                marginTop: 32,
                padding: "18px 20px",
                background: "rgba(139,92,246,0.07)",
                border: "1px solid #3A2D63",
                gridTemplateColumns: "auto 1fr",
                gap: 16,
              }}
            >
              <div
                className="text-[#A78BFA]"
                style={{ fontSize: 40, lineHeight: 1 }}
              >
                30
              </div>
              <div className="text-[14.5px] leading-[1.5] text-[#D3CCE6]">
                <span className="font-semibold text-[#EEEDF2]">
                  Días de garantía.
                </span>{" "}
                Si no ves una mejora real en tu proceso comercial, te devolvemos
                tu inversión.
              </div>
            </div>
          </div>

          {/* Right — included list */}
          <div className="flex flex-col gap-3.5 justify-center p-8 lg:p-14">
            {included.map((x) => (
              <div
                key={x}
                className="grid pb-3.5"
                style={{
                  gridTemplateColumns: "22px 1fr",
                  gap: 8,
                  lineHeight: 1.45,
                  borderBottom: "1px solid #241E36",
                }}
              >
                <span className="text-[#A78BFA]">✓</span>
                <span className="text-[#EEEDF2]">{x}</span>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
}
